module.exports = __webpack_public_path__ + "img/b5.98db3c76.png";